<template>
  <div>
    <span
      v-for="(mantraObj, mantra_id) in Constants.RUOLI_MANTRA"
      :key="mantra_id"
      @click="toggleRuoloMantra(mantra_id)"
      class="ruolo-mantra"
      :class="{
        ['ruolo-mantra' + mantra_id]: true,
        outlined: !selectedRuoliMantra.includes(mantra_id),
      }"
      >{{ ruoloMantra(mantra_id) }}</span
    >
  </div>
</template>

<script>
import Constants from "../../js/constants";
import mixins from "../../js/mixins";

export default {
  name: "select-ruoli-mantra",
  components: {},
  mixins: [mixins],
  mounted() {
    console.log("--> SelectRuoliMantra ready.");
  },
  destroyed() {
    console.log("<-- SelectRuoliMantra destroyed.");
  },
  model: {
    prop: "selectedRuoliMantra",
    event: "change",
  },
  props: {
    selectedRuoliMantra: {
      type: Array,
      default: [],
    },
  },
  methods: {
    toggleRuoloMantra(mantra_id) {
      const index = this.selectedRuoliMantra.indexOf(mantra_id);
      if (index === -1) {
        this.selectedRuoliMantra.push(mantra_id);
      } else {
        this.selectedRuoliMantra.splice(index, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ruolo-mantra {
  cursor: pointer;
  margin: 3px;
  padding: 2px 6px;
  &:hover {
    opacity: 0.7;
  }
}
</style>
